// extracted by mini-css-extract-plugin
export default {"welcome_message_container":"home_welcome_message_container__JL8HR","welcome_message_wrap":"home_welcome_message_wrap__+97cP"};